import axios from 'axios';
import qs from 'querystring';

export default class ApiStore {
  constructor() {

    if (process.env.NODE_ENV == 'development') {
      axios.defaults.baseURL = process.env.REACT_APP_API_HOST;
    } else {
      let parts = window.location.hostname.split('.');
      const DOMAINNAME = parts[1] + '.' + parts[2];
      const SITE_APP = parts.shift();
      axios.defaults.baseURL = 'https://api.' + DOMAINNAME + '/' + SITE_APP;
    }

    this.config = {
      withCredentials: true,
    };
    axios.interceptors.request.use(function(config) {
      // Do something before request is sent
      config['withCredentials'] = true;

      return config;
    }, function(error) {
      // Do something with request error
      return Promise.reject(error);
    });
  }

  getBaseUrl(){
    return axios.defaults.baseURL
  }

  wrapResponse (promise) {
    return promise.then(response => {
      return response && response.data;
    }).catch(error => {
      console.log(error);
      return {status:'error'}
    });
  }

}



// WEBPACK FOOTER //
// ./src/stores/ApiStore.js